import { render, staticRenderFns } from "./PageHeaderPitch.vue?vue&type=template&id=6f4b08f6"
import script from "./PageHeaderPitch.vue?vue&type=script&lang=js"
export * from "./PageHeaderPitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports